/**
 * Imperatively reset uncontrolled form input elements
 */
function resetFilters(form: HTMLFormElement, resetTypeField = true) {
  // Reset radio buttons for reviewable type
  if (resetTypeField) {
    const defaultType = form.querySelectorAll(
      "input[type=radio][name=type]"
    )[0];
    (defaultType as HTMLInputElement).checked = true;
  }

  // Uncheck all checkbox inputs
  form.querySelectorAll("input[type=checkbox]").forEach((element) => {
    (element as HTMLInputElement).checked = false;
  });

  // Reset all text-based inputs
  form
    .querySelectorAll("input[type=date],input[type=number],input[type=text]")
    .forEach((element) => {
      (element as HTMLInputElement).value = "";
    });
}

export { resetFilters };
